// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"d7c5da52","729":"d3367efc"}[chunkId] + ".css";
};